// src/components/AppLayout.tsx
import React from 'react';
import { Box, Container } from '@mui/material';
import Footer from './Footer'; // Assuming Footer is in the same components directory
import Banner from './Banner'; // Assuming Banner is in the same components directory
import HeroCarousel from './HeroCarousel';

type AppLayoutProps = {
  children: React.ReactNode;
};

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh', // Ensures layout takes up the full viewport height
        width:'100%'
      }}
    >
      {/* Banner Component at the Top */}
      <Banner />

      {/* Main Content Section */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
         // py: 3, // Padding for spacing
        }}
      >
        <Box sx={{ width: "100%" }}>
          {children} {/* Content from the children prop (injected routes) */}
        </Box>
      </Box>

      {/* Footer Component at the Bottom */}
      <Footer />
    </Box>
  );
};

export default AppLayout;
